export default "__VITE_ASSET__CUGLx5Vl__"